import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface IPaystatementState {
  sendDate: Date;
  acceptEmpSeq: string;
  payStoreSeq: number;
  payKakaoSeq: number;
}
export interface ISendPay extends IPaystatementState {
  setSendPay: (data: IPaystatementState) => void;
}

const usePaystatementStore = create<ISendPay>()(
  persist(
    (set, get) => ({
      sendDate: new Date(),
      acceptEmpSeq: '',
      payStoreSeq: 0,
      payKakaoSeq: 0,
      setSendPay: (data: IPaystatementState) =>
        set((state) => {
          return {
            sendDate: data.sendDate,
            acceptEmpSeq: data.acceptEmpSeq,
            payStoreSeq: data.payStoreSeq,
            payKakaoSeq: data.payKakaoSeq,
          };
        }),
    }),
    {
      name: 'sendPay-storage',
      onRehydrateStorage: (state) => {
        // console.log('hydration starts', state);

        return (state, error) => {
          if (error) {
            console.log('an error happened during hydration', error);
          } else {
            // console.log('hydration finished', state);
          }
        };
      },
    },
  ),
);

export default usePaystatementStore;
